import { Card } from '../Card';
import { ChargingStation } from 'services/centralServerService/data-contracts';
import MapComponent from 'components/Maps/MapComponent';
import OpenInMapsButton from '../OpenInMaps';
import React from 'react';
import { Typography } from '@mui/material';

export const MapCard: React.FC<{
    chargeBoxId: string;
    charger: ChargingStation | undefined;
}> = ({ charger, chargeBoxId }) => {
    return (
        <Card style={{ height: '23vh', pointerEvents: 'none' }}>
            <MapComponent
                showCenter
                disableZoom
                disableDragging
                mapZoom={15}
                mapCenter={{
                    lat: charger?.coordinates?.[1] || 0,
                    lng: charger?.coordinates?.[0] || 0,
                }}
            />
            <div
                style={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    zIndex: 100,
                    width: '100%',
                    backgroundColor: 'rgba(0,0,0,0.5)',
                    color: 'white',
                    padding: '0.5rem',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}
            >
                <div>
                    <Typography variant="body2" style={{ fontWeight: 'bold' }}>
                        {chargeBoxId}
                    </Typography>
                </div>
                <div style={{ marginRight: 15 }}>
                    <OpenInMapsButton
                        latitude={charger?.coordinates?.[1]}
                        longitude={charger?.coordinates?.[0]}
                    />
                </div>
            </div>
        </Card>
    );
};
